import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Field, SubmitButton } from "@/components/site/FormBits";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="forgot-password-page">
      <p className="eyebrow">Account</p>
      <h1 className="mt-4 font-display text-4xl tracking-tight">Forgot your password?</h1>
      {sent ? (
        <div data-testid="forgot-success" className="mt-8 bg-white border border-[#E4E1D9] p-6 text-sm text-[#57534E] leading-relaxed">
          If an account exists for <strong className="text-[#121417]">{email}</strong>, we've emailed a link to reset your password. It expires in 1 hour. Check your spam folder if it doesn't arrive.
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-5">
          <p className="text-sm text-[#57534E]">Enter your account email and we'll send you a reset link.</p>
          <Field label="Email" required>
            <input data-testid="forgot-input-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field-input" />
          </Field>
          {error && <p data-testid="forgot-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2">{error}</p>}
          <SubmitButton loading={loading} testId="forgot-submit-btn" className="w-full">Send reset link</SubmitButton>
        </form>
      )}
      <Link to="/auth" data-testid="forgot-back-signin" className="mt-6 inline-block text-sm text-[#9F7E44] hover:text-[#866835]">Back to sign in</Link>
    </div>
  );
}
